<template>
  <div>
	<top />
	<div style="width: 100%;height: 55px;"></div>
    <div class="container">
      <div class="content">
        <!-- <div class="title">免责声明</div> -->
        <div class="text-area" v-html="content"></div>
        <!-- <quillEditor v-model="content" /> -->
      </div>
    </div>
	<info />
	<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
	<foot />
  </div>
</template>

<script>
import top from "../../components/common/header.vue";
import foot from "../../components/common/footer.vue";
import info from "../../components/common/qrCode.vue";
import { clauseData } from "../../request/api";

export default {
  components: {
    top,
    foot,
	info
  },

  data() {
    return {
      content: "",
      type: "",
    };
  },

  created() {
	document.title = '以图绘图印花设计网';
    this.type = this.$route.query.type
    this.getClauseData();
  },

  watch: {
    $route: {
      handler() {
        this.type = this.$route.query.type;
        this.getClauseData();
        //深度监听，同时也可监听到param参数变化
      },
      deep: true,
    },
  },
  methods: {
    getClauseData() {
      clauseData({
        type: this.type,
      }).then((res) => {
        console.log(res);
        this.content = this.showHtml(res.data);
      });
    },

    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  

  .content {
    margin: 0 auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>